module.exports = __webpack_public_path__ + "img/men_wear_hover.a5a75846.png";